module.exports = __webpack_public_path__ + "img/pakistan.2dba16b.webp";